﻿package com.mgacreative.hotelru.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class PosItem(
    val id: String = "",
    val tenant_id: String = "",
    val category_id: String,
    val name: String,
    val price: Double,
    val is_available: Boolean = true,
    val created_at: String = ""
)

